import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'usage-bar',
    props: {
        usage: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        background: {
            type: String,
            default: '#E6F0FF'
        },
        fillBackground: {
            type: String,
            default: '#3489FE'
        }
    },
    setup(__props) {
        const props = __props;
        const fillWidth = computed(() => {
            if (props.max === 0) {
                return '0%';
            }
            const percent = (props.usage / props.max) * 100;
            return Math.min(percent, 100) + '%';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "usage-bar-container",
                style: _normalizeStyle({ background: __props.background })
            }, [
                _createElementVNode("div", {
                    class: "usage-bar-fill",
                    style: _normalizeStyle({
                        width: fillWidth.value,
                        background: __props.fillBackground
                    })
                }, null, 4)
            ], 4));
        };
    }
});
